import React, { useEffect, useState } from "react";
import { useAuth } from "../../contexts/auth";
import { composeLanguages } from "../../utils";

const Language = () => {
  const [composedLang, setLang] = useState([]);
  const { languages, activeLangs, userConfig } = useAuth();

  useEffect(() => {
    setLang(composeLanguages(languages, activeLangs, userConfig.country));
  }, [languages, activeLangs, userConfig]);

  return (
    <table className="table table-bordered align-middle mt-1">
      <thead className="table-dark">
        <tr>
          <th scope="col">Name</th>
          <th scope="col">Native Name</th>
          <th scope="col">Active</th>
        </tr>
      </thead>
      <tbody>
        {composedLang.map((lang) => {
          return (
            <tr
              className={
                lang.activeStatus === "Not available in this country"
                  ? "table-active"
                  : ""
              }
            >
              <td>{lang.name}</td>
              <td>{lang.nativeName}</td>
              <td>{lang.activeStatus}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default Language;
